import type { ReactNode } from 'react';
import { cn } from '@/lib/utils';

export interface FieldLabelMobileProps {
  label?: string;
  htmlFor?: string;
  required?: boolean;
  error?: string;
  helperText?: string;
  /** Shown at the right end of the label row (a link such as "Lupa Password?") */
  labelAction?: ReactNode;
  className?: string;
  children: ReactNode;
}

const FieldLabelMobile = ({
  label,
  htmlFor,
  required = false,
  error,
  helperText,
  labelAction,
  className,
  children,
}: FieldLabelMobileProps) => {
  return (
    <div className={cn('flex w-full flex-col gap-1.5', className)}>
      {label && (
        <div className="flex items-center justify-between gap-3">
          <label htmlFor={htmlFor} className="field-mobile-label body1 text-text-grey">
            {label}
            {required && <span className="ml-0.5 text-text-danger-500">*</span>}
          </label>
          {labelAction}
        </div>
      )}
      {children}
      {error ? (
        <p className="reg12 text-text-danger-500">{error}</p>
      ) : (
        helperText && <p className="reg12 text-text-grey">{helperText}</p>
      )}
    </div>
  );
};

export default FieldLabelMobile;
